import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';
import { Image } from '../atoms/image'
import { Button } from '../atoms/button'

export const FirstView = () =>
  <section className="firstview">
    <div className="firstview--in">
      <h1 className="firstview--title">高品質なアライナー矯正システム</h1>
      <div className="firstview--alignCenter">
        <Fade left cascade duration={500} distance="40px">
          <Image className="firstview--logo" imageName="logo-large.png" />
        </Fade>
      </div>
      <div className="firstview--alignCenter">
        <Fade left cascade duration={500} delay={200} distance="40px">
          <Image className="firstview--arainer" imageName="arainer.png" />
        </Fade>
      </div>
      <div className="firstview--informationAndCircleWrap">
        <Fade left cascade duration={500} delay={400} distance="40px">
          <div className="firstview--alignCenter">
            <Button onClick={() => window.location.href = "https://deltan.my.salesforce-sites.com/enqueteForm?prm=hanalove"}>
              <span translate='no'>お問い合わせ</span>
              <i className="fas fa-chevron-right"></i>
            </Button>
          </div>
          <div className="firstview--alignCenter">
            <p className="firstview--description">無料導入可能！お気軽にご予約ください。</p>
          </div>
        </Fade>
        <Fade right cascade duration={500} delay={400} distance="40px">
          <div className="firstview--circleArea">
            <Image className="firstview--circleArea--circle" imageName="first-circle.png" />
            <p className="firstview--circleArea--text">※2022年6月時点</p>
          </div>
        </Fade>
      </div>
      <Fade bottom cascade duration={500} delay={500} distance="40px">
        <div className="firstview--scrollArea">
          <span translate='no' className="firstview--scrollArea--label">SCROLL</span>
        </div>
      </Fade>
    </div>
  </section>